module.exports = __webpack_public_path__ + "static/img/best_screenplay_mob.deb6f7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/best_screenplay_mob.jpg
// module id = 84
// module chunks = 0